/* tslint:disable */
import {
  Apptype,
  Tenant,
  App
} from '../index';

declare var Object: any;
export interface PicktableInterface {
  name: string;
  label: string;
  condition?: string;
  sortorder?: number;
  description: string;
  lastupdatedby?: string;
  createdby?: string;
  id?: any;
  apptypeId?: any;
  tenantId?: any;
  appId?: any;
  createdAt: Date;
  updatedAt: Date;
  apptype?: Apptype;
  tenant?: Tenant;
  app?: App;
}

export class Picktable implements PicktableInterface {
  name: string;
  label: string;
  condition: string;
  sortorder: number;
  description: string;
  lastupdatedby: string;
  createdby: string;
  id: any;
  apptypeId: any;
  tenantId: any;
  appId: any;
  createdAt: Date;
  updatedAt: Date;
  apptype: Apptype;
  tenant: Tenant;
  app: App;
  constructor(data?: PicktableInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Picktable`.
   */
  public static getModelName() {
    return "Picktable";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Picktable for dynamic purposes.
  **/
  public static factory(data: PicktableInterface): Picktable{
    return new Picktable(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Picktable',
      plural: 'picktables',
      properties: {
        name: {
          name: 'name',
          type: 'string'
        },
        label: {
          name: 'label',
          type: 'string'
        },
        condition: {
          name: 'condition',
          type: 'string'
        },
        sortorder: {
          name: 'sortorder',
          type: 'number'
        },
        description: {
          name: 'description',
          type: 'string'
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        apptypeId: {
          name: 'apptypeId',
          type: 'any'
        },
        tenantId: {
          name: 'tenantId',
          type: 'any'
        },
        appId: {
          name: 'appId',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        apptype: {
          name: 'apptype',
          type: 'Apptype',
          model: 'Apptype'
        },
        tenant: {
          name: 'tenant',
          type: 'Tenant',
          model: 'Tenant'
        },
        app: {
          name: 'app',
          type: 'App',
          model: 'App'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Picktable.ts